module.exports = __webpack_public_path__ + "static/media/iot_logo.aea0b47a.png";